// extracted by mini-css-extract-plugin
export default {"container":"MasterContainer_container__FjXba"};